export default __webpack_public_path__ + "8c0f853714b6db599c9a4da84cc292e4.svg";